import { createStore, applyMiddleware } from "redux";
import rootReducer from "../reducer/index.js";
import subscriber from "../subscribers/index";

import { rootWatcher } from "../saga/saga";
import createSagaMiddleware from "redux-saga";
import axios from "axios";
import { ADD_NEW_SERVICES, ADD_NEW_DRIVERS } from "../constants/actions-types";
import io from "socket.io-client";
import { socket_base_url } from "../constants/routes.js";
let query = undefined;
let token = localStorage.getItem("token");
if (token != undefined) {
  query = { query: "token=" + token };
}

const sagaMiddleware = createSagaMiddleware();
console.log(query);
var server = io(socket_base_url, query);

server.on("connect", function () {
  console.log("WebSocket connection established");
  server.emit("hello", { msg: "sample message here" });
});

server.on("disconnect", function () {
  console.log("WebSocket connection closed");
});

window.server = server;
const store = createStore(rootReducer, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(rootWatcher);
/*
**********************************************************
please export data before uncomment next line :BE CAREFUL:
store.dispatch({ type: REMOVE__DATA })
**********************************************************
*/
window.store = store;
var item = localStorage.getItem("token");
axios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.getItem("token");

// store.dispatch({ type: ADD_CUSTOMERS });
store.dispatch({ type: ADD_NEW_SERVICES });
store.dispatch({ type: ADD_NEW_DRIVERS });

// server.on("changed", function() {
//   store.dispatch({ type: ADD_CUSTOMERS });
//   store.dispatch({ type: ADD_NEW_SERVICES });
//   store.dispatch({ type: ADD_NEW_DRIVERS });
// });

// store.dispatch(addServices(makeServices()));
// store.dispatch(addDrivers(makeDrivers()));
// store.dispatch({ type: "DEMO_CALL" });
store.subscribe(subscriber);
export default store;
